import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, LayoutDashboard, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-[#E8D7D0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between gap-6">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2">
          <span className="font-logo text-2xl text-[#B76E79] tracking-wide">Wonderpro</span>
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.28em] text-[#5E5356]">
            Esthétique &amp; Cosmétique
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {user ? (
            <>
              <Button
                variant="ghost"
                data-testid="nav-dashboard-btn"
                onClick={() => navigate("/ressources")}
                className="rounded-full text-[#2C2627] hover:bg-[#F5E6E8] hover:text-[#B76E79]"
              >
                <LayoutDashboard strokeWidth={1.5} className="w-4 h-4 mr-2" />
                Ressources
              </Button>
              {user.role === "admin" && (
                <Button
                  variant="ghost"
                  data-testid="nav-admin-btn"
                  onClick={() => navigate("/admin")}
                  className="rounded-full text-[#2C2627] hover:bg-[#F5E6E8] hover:text-[#B76E79]"
                >
                  <ShieldCheck strokeWidth={1.5} className="w-4 h-4 mr-2" />
                  Admin
                </Button>
              )}
              <Button
                data-testid="nav-logout-btn"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                className="rounded-full bg-[#B76E79] hover:bg-[#A25D67] text-white"
              >
                <LogOut strokeWidth={1.5} className="w-4 h-4 mr-2" />
                Quitter
              </Button>
            </>
          ) : (
            <>
              <Link
                to="/connexion"
                data-testid="nav-login-link"
                className="text-sm text-[#5E5356] hover:text-[#B76E79] transition-colors px-3 py-2"
              >
                Connexion
              </Link>
              <Button
                data-testid="nav-register-btn"
                onClick={() => navigate("/inscription")}
                className="rounded-full bg-[#B76E79] hover:bg-[#A25D67] text-white"
              >
                S'inscrire
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};
